import React from 'react';
import classNames from 'classnames';
import { Route, useLocation } from 'react-router-dom';
import { AppTopbar } from './AppTopbar';
import { AppFooter } from './AppFooter';
import { AppMenu } from './AppMenu';
//import Dashboard from './components/Dashboard';
import Dashboard from './components/Dashboard';
import ButtonDemo from './components2/ButtonDemo';
import ChartDemo from './components2/ChartDemo';
import Documentation from './components2/Documentation';
import FileDemo from './components2/FileDemo';
import FloatLabelDemo from './components2/FloatLabelDemo';
import FormLayoutDemo from './components2/FormLayoutDemo';
import InputDemo from './components2/InputDemo';
import ListDemo from './components2/ListDemo';
import MenuDemo from './components2/MenuDemo';
import MessagesDemo from './components2/MessagesDemo';
import MiscDemo from './components2/MiscDemo';
import OverlayDemo from './components2/OverlayDemo';
import MediaDemo from './components2/MediaDemo';
import PanelDemo from './components2/PanelDemo';
import TableDemo from './components2/TableDemo';
import TreeDemo from './components2/TreeDemo';
import InvalidStateDemo from './components2/InvalidStateDemo';
import BlocksDemo from './components2/BlocksDemo';
import IconsDemo from './components2/IconsDemo';
import Crud from './pages/Crud';
import EmptyPage from './pages/EmptyPage';
import TimelineDemo from './pages/TimelineDemo';
import Institution from './components/Institution';
import Institution2 from './components2/Institution2';
import TextTable from './components2/TextTable';
import TestTableIns from './components2/TestTableIns';
import Suppression from './components2/Suppression';
import Lieu from './components/Lieu';
import Niveau from './components/Niveau';
import Structure from './components/Structure';
import Utilisateur from './components/Utilisateur';
import Vehicule from './components/Vehicule';
import Chauffeur from './components/Chauffeur';
import Compte from './components/Compte';
import DemandeVehicule from './components/DemandeVehicule';
import Form from './components2/Form';
import './App.scss';
import { CommonService } from './util/CommonService';
import UpdatePassword from './components/UpdatePassword';
import Traitement from './components/Traitement';
import ResponTraitement from './components/ResponTraitement';
import PointParking from './components/PointParking';
import Plaque from './components/Plaque';
import Financement from './components/Financement';
import TypeMateriel from './components/TypeMateriel';
import Tiers from './components/Tiers';
import TypeTiers from './components/TypeTiers';
import Assurance from './components/Assurance';
import TypeAssurance from './components/TypeAssurance';
import Location from './components/Location';
import Maintenance from './components/Maintenance';
import TypeMaintenance from './components/TypeMaintenance';
import TypeContrat from './components/TypeContrat';
import Contrat from './components/Contrat';
import PieceRechange from './components/PieceRechange';
import DeclarationMaintenance from './components/DeclarationMaintenance';
import MouvementPiece from './components/MouvementPiece';
import PointAssurance from './components/PointAssurance';
import EtatMateriel from './components/EtatMateriel';
import DisponibiliteVehicule from './components/DisponibiliteVehicule';
import EtatChauffeur from './components/EtatChauffeur';
import PointLocation from './components/PointLocation';
import DisponibiliteChauffeur from './components/DisponibiliteChauffeur';
import ConnectedButton from './ConnectedButton';
import PieceRechangeStock from './components/PiecesRechangeStock';


const App = (props) => {
    const dataUser = localStorage.getItem("user");
    const user = JSON.parse(dataUser);
    
    let typeUser = user?.utilisateur?.typeUtilisateur; 
    
    let monTableau = [];
    
    if(typeUser === "ADMINISTRATEUR") {
        monTableau = [
            {
                label: 'Accueil',
                items: [
                    { label: 'Tableau de bord', icon: 'pi pi-fw pi-home', to: '/dashboard' }
                ]
            },
            {
                label: 'Gestion des véhicules',
                items: [
                    { label: 'Type de véhicule', icon: 'pi pi-fw pi-list', to: '/typeMateriel' },
                    { label: 'Véhicule', icon: 'pi pi-fw pi-car', to: '/vehicule' },
                    { label: 'Plaque', icon: 'pi pi-fw pi-credit-card', to: '/plaque' },
                    { label: 'Financement', icon: 'pi pi-fw pi-money-bill', to: '/financement' },
                    { label: 'Etat véhicule', icon: 'pi pi-fw pi-car', to: '/etatMateriel' },
                ]
            },

            {
                label: 'Gestion des Chauffeurs',
                items: [
                    { label: 'Chauffeur', icon: ' pi pi-fw pi-users', to: '/chauffeur' },
                    { label: 'Disponibilité de chauffeur', icon: 'pi pi-fw pi-users', to: '/disponibiliteChauffeur' },
                    { label: 'Etat chauffeur', icon: 'pi pi-fw pi-users', to: '/etatChauffeur' },
                ]
            },

            {
                label: 'Gestion des Tiers',
                items: [
                    { label: 'Type tiers', icon: 'pi pi-fw pi-list', to: '/typeTiers' },
                    { label: 'Tiers', icon: 'pi pi-fw pi-list', to: '/tiers' },
                ]
            },

            {
                label: 'Gestion des missions',
                items: [
                    { label: 'Demande de véhicule', icon: 'pi pi-fw pi-car', to: '/demande' },
                    { label: 'Traitement des demandes', icon: 'pi pi-fw pi-car', to: '/traitement' },
                    { label: 'Disponibilité de véhicule', icon: 'pi pi-fw pi-car', to: '/disponibiliteVehicule' },
                ]
            },

            {
                label: 'Gestion des assurances',
                items: [
                    { label: 'Type assurance', icon: 'pi pi-fw pi-list', to: '/typeAssurance' },
                    { label: 'Assurance', icon: 'pi pi-fw pi-car', to: '/assurance' },
                    { label: 'Point des assurances', icon: 'pi pi-fw pi-list', to: '/pointAssurance' },
                ]
            },

            {
                label: 'Gestion des locations',
                items: [
                    { label: 'Location', icon: 'pi pi-fw pi-car', to: '/location' },
                    { label: 'Traitement des demandes', icon: 'pi pi-fw pi-list', to: '/traitement' },
                    { label: 'Point des locations', icon: 'pi pi-fw pi-list', to: '/pointLocation' },
                ]
            },

            {
                label: 'Gestion des réparations',
                items: [
                    { label: 'Type contrat', icon: 'pi pi-fw pi-car', to: '/typeContrat' },
                    { label: 'Contrat', icon: 'pi pi-fw pi-car', to: '/contrat' },
                    { label: 'Déclaration maintenance', icon: 'pi pi-fw pi-car', to: '/declarationMaintenance' },
                    { label: 'Type maintenance', icon: 'pi pi-fw pi-car', to: '/typeMaintenance' },
                    { label: 'Maintenance', icon: 'pi pi-fw pi-car', to: '/maintenance' },
                    { label: 'Mouvement pièces', icon: 'pi pi-fw pi-car', to: '/mouvementPiece' },
                    { label: 'Pièces de rechange', icon: 'pi pi-fw pi-car', to: '/piecesRechange' },
                    { label: 'Stock pièces', icon: 'pi pi-fw pi-car', to: '/piecesRechangeStock' }
                ]
            },

            {
                label: ' Autres paramètres',
                items: [

                    { label: 'Institution', icon: 'pi pi-fw pi-list', to: '/institution' },
                    { label: 'Lieu', icon: ' pi pi-fw pi-list', to: '/lieu' },
                    { label: 'Niveau', icon: 'pi pi-fw pi-list', to: '/niveau' },
                    { label: 'Structure', icon: 'pi pi-fw pi-list', to: '/structure' },
                ]
            },

            {
                label: 'Administration',
                items: [
                    { label: 'Compte', icon: ' pi pi-fw pi-user-edit', to: '/compte' },
                    { label: 'Utilisateur', icon: 'pi pi-fw pi-users', to: '/utilisateur' },
                ]
            },
        ]
    }else if(typeUser === "CHEF_PARC"){
        monTableau = [
            {
                label: 'Accueil',
                items: [
                    { label: 'Tableau de bord', icon: 'pi pi-fw pi-home', to: '/dashboard' }
                ]
            },
            {
                label: 'Gestion des véhicules',
                items: [
                    { label: 'Type de véhicule', icon: 'pi pi-fw pi-list', to: '/typeMateriel' },
                    { label: 'Véhicule', icon: 'pi pi-fw pi-car', to: '/vehicule' },
                    { label: 'Plaque', icon: 'pi pi-fw pi-credit-card', to: '/plaque' },
                    { label: 'Financement', icon: 'pi pi-fw pi-money-bill', to: '/financement' },
                    { label: 'Etat véhicule', icon: 'pi pi-fw pi-car', to: '/etatMateriel' },
                ]
            },

            {
                label: 'Gestion des chauffeurs',
                items: [
                    { label: 'Chauffeur', icon: ' pi pi-fw pi-users', to: '/chauffeur' },
                    { label: 'Disponibilité de chauffeur', icon: 'pi pi-fw pi-users', to: '/disponibiliteChauffeur' },
                    { label: 'Etat chauffeur', icon: 'pi pi-fw pi-users', to: '/etatChauffeur' },
                ]
            },

            {
                label: 'Gestion des Tiers',
                items: [
                    { label: 'Type tiers', icon: 'pi pi-fw pi-list', to: '/typeTiers' },
                    { label: 'Tiers', icon: 'pi pi-fw pi-list', to: '/tiers' },
                ]
            },

            {
                label: 'Gestion des missions',
                items: [
                    { label: 'Demande de véhicule', icon: 'pi pi-fw pi-car', to: '/demande' },
                    { label: 'Traitement des demandes', icon: 'pi pi-fw pi-car', to: '/traitement' },
                    { label: 'Disponibilité de véhicule', icon: 'pi pi-fw pi-car', to: '/disponibiliteVehicule' },
                ]
            },

            {
                label: 'Gestion des assurances',
                items: [
                    { label: 'Type assurance', icon: 'pi pi-fw pi-list', to: '/typeAssurance' },
                    { label: 'Assurance', icon: 'pi pi-fw pi-car', to: '/assurance' },
                    { label: 'Point des assurances', icon: 'pi pi-fw pi-list', to: '/pointAssurance' },
                ]
            },

            {
                label: 'Gestion des locations',
                items: [
                    { label: 'Location', icon: 'pi pi-fw pi-car', to: '/location' },
                    { label: 'Traitement des demandes', icon: 'pi pi-fw pi-car', to: '/traitement' },
                    { label: 'Point des locations', icon: 'pi pi-fw pi-list', to: '/pointLocation' },
                ]
            },

            {
                label: 'Gestion des réparations',
                items: [
                    { label: 'Type contrat', icon: 'pi pi-fw pi-car', to: '/typeContrat' },
                    { label: 'Contrat', icon: 'pi pi-fw pi-car', to: '/contrat' },
                    { label: 'Déclaration maintenance', icon: 'pi pi-fw pi-car', to: '/declarationMaintenance' },
                    { label: 'Type maintenance', icon: 'pi pi-fw pi-car', to: '/typeMaintenance' },
                    { label: 'Maintenance', icon: 'pi pi-fw pi-car', to: '/maintenance' },
                    { label: 'Mouvement pièces', icon: 'pi pi-fw pi-car', to: '/mouvementPiece' },
                    { label: 'Pièces de rechange', icon: 'pi pi-fw pi-car', to: '/piecesRechange' },
                    { label: 'Stock pièces', icon: 'pi pi-fw pi-car', to: '/piecesRechangeStock' }
                ]
            }
        ]

    }else if(typeUser === "RESPONSABLE_STRUCTURE"){
        monTableau = [
            {
                label: 'Accueil',
                items: [
                    { label: 'Tableau de bord', icon: 'pi pi-fw pi-home', to: '/dashboard' }
                ]
            },
            {
                label: 'Opération',
                items: [
                    { label: 'Demande de véhicule', icon: 'pi pi-fw pi-car', to: '/demande' },
                    { label: 'Traitement des demandes', icon: 'pi pi-fw pi-car', to: '/traitement' },
                ]
            }
        ]

    } else if(typeUser === "SIMPLE_UTILISATEUR"){
        monTableau = [
            {
                label: 'Accueil',
                items: [
                    { label: 'Tableau de bord', icon: 'pi pi-fw pi-home', to: '/dashboard' }
                ]
            },
            {
                label: 'Opération',
                items: [
                    { label: 'Demande de véhicule', icon: 'pi pi-fw pi-car', to: '/demande' },
                ]
            }
        ]
    } else if(typeUser === "TEST"){
        monTableau = [
            {
                label: 'Accueil',
                items: [
                    { label: 'Tableau de bord', icon: 'pi pi-fw pi-home', to: '/dashboard' }
                ]
            },
            {
                label: 'Gestion des véhicules',
                items: [
                    { label: 'Type de véhicules', icon: 'pi pi-fw pi-list', to: '/typeMateriel' },
                    { label: 'Véhicule', icon: 'pi pi-fw pi-car', to: '/vehicule' },
                    { label: 'Plaque', icon: 'pi pi-fw pi-credit-card', to: '/plaque' },
                    { label: 'Financement', icon: 'pi pi-fw pi-money-bill', to: '/financement' },
                    { label: 'Etat du véhicule', icon: 'pi pi-fw pi-car', to: '/etatMateriel' },
                ]
            },

            {
                label: 'Gestion des Chauffeurs',
                items: [
                    { label: 'Chauffeurs', icon: ' pi pi-fw pi-users', to: '/chauffeur' },
                    { label: 'Disponibilité de chauffeur', icon: 'pi pi-fw pi-users', to: '/disponibiliteChauffeur' },
                    { label: 'Etat chauffeur', icon: 'pi pi-fw pi-users', to: '/etatChauffeur' },
                ]
            },

            {
                label: 'Gestion des Tiers',
                items: [
                    { label: 'Type tiers', icon: 'pi pi-fw pi-list', to: '/typeTiers' },
                    { label: 'Tiers', icon: 'pi pi-fw pi-list', to: '/tiers' },
                ]
            },

            {
                label: 'Gestion des missions',
                items: [
                    { label: 'Demande de véhicule', icon: 'pi pi-fw pi-car', to: '/demande' },
                    { label: 'Traitement des demandes', icon: 'pi pi-fw pi-car', to: '/traitement' },
                    { label: 'Disponibilité en véhicule', icon: 'pi pi-fw pi-car', to: '/disponibiliteVehicule' },
                ]
            },

            {
                label: 'Gestion des assurances',
                items: [
                    { label: 'Type assurance', icon: 'pi pi-fw pi-list', to: '/typeAssurance' },
                    { label: 'Assurance', icon: 'pi pi-fw pi-car', to: '/assurance' },
                    { label: 'Point des assurances', icon: 'pi pi-fw pi-list', to: '/pointAssurance' },
                ]
            },

            {
                label: 'Gestion des locations',
                items: [
                    { label: 'Location', icon: 'pi pi-fw pi-car', to: '/location' },
                    { label: 'Traitement des demandes', icon: 'pi pi-fw pi-car', to: '/traitement' },
                    { label: 'Point des locations', icon: 'pi pi-fw pi-list', to: '/pointLocation' },
                ]
            },

            {
                label: 'Gestion des réparations',
                items: [
                    { label: 'Type contrat', icon: 'pi pi-fw pi-car', to: '/typeContrat' },
                    { label: 'Contrat', icon: 'pi pi-fw pi-car', to: '/contrat' },
                    { label: 'Déclaration maintenance', icon: 'pi pi-fw pi-car', to: '/declarationMaintenance' },
                    { label: 'Type maintenance', icon: 'pi pi-fw pi-car', to: '/typeMaintenance' },
                    { label: 'Maintenance', icon: 'pi pi-fw pi-car', to: '/maintenance' },
                    { label: 'Mouvement pièces', icon: 'pi pi-fw pi-car', to: '/mouvementPiece' },
                    { label: 'Pièces de rechange', icon: 'pi pi-fw pi-car', to: '/piecesRechange' },
                    { label: 'Stock pièces', icon: 'pi pi-fw pi-car', to: '/piecesRechangeStock' }
                ]
            },

            {
                label: ' Autres paramètres',
                items: [

                    { label: 'Institution', icon: 'pi pi-fw pi-list', to: '/institution' },
                    { label: 'Lieu', icon: ' pi pi-fw pi-list', to: '/lieu' },
                    { label: 'Niveau', icon: 'pi pi-fw pi-list', to: '/niveau' },
                    { label: 'Structure', icon: 'pi pi-fw pi-list', to: '/structure' },
                ]
            },

            {
                label: 'Administration',
                items: [
                    { label: 'Compte', icon: ' pi pi-fw pi-user-edit', to: '/compte' },
                    { label: 'Utilisateur', icon: 'pi pi-fw pi-users', to: '/utilisateur' },
                ]
            },

            {
                label: 'UI components2', icon: 'pi pi-fw pi-sitemap',
                items: [
                    { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', to: '/formlayout' },
                    { label: 'Input', icon: 'pi pi-fw pi-check-square', to: '/input' },
                    { label: "Float Label", icon: "pi pi-fw pi-bookmark", to: "/floatlabel" },
                    { label: "Invalid State", icon: "pi pi-fw pi-exclamation-circle", to: "invalidstate" },
                    { label: 'Button', icon: 'pi pi-fw pi-mobile', to: '/button' },
                    { label: 'Table', icon: 'pi pi-fw pi-table', to: '/table' },
                    { label: 'List', icon: 'pi pi-fw pi-list', to: '/list' },
                    { label: 'Tree', icon: 'pi pi-fw pi-share-alt', to: '/tree' },
                    { label: 'Panel', icon: 'pi pi-fw pi-tablet', to: '/panel' },
                    { label: 'Overlay', icon: 'pi pi-fw pi-clone', to: '/overlay' },
                    { label: "Media", icon: "pi pi-fw pi-image", to: "/media" },
                    { label: 'Menu', icon: 'pi pi-fw pi-bars', to: '/menu' },
                    { label: 'Message', icon: 'pi pi-fw pi-comment', to: '/messages' },
                    { label: 'File', icon: 'pi pi-fw pi-file', to: '/file' },
                    { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', to: '/chart' },
                    { label: 'Misc', icon: 'pi pi-fw pi-circle-off', to: '/misc' },
                ]
            },
            {
                label: 'UI Blocks',
                items: [
                    { label: 'Free Blocks', icon: 'pi pi-fw pi-eye', to: '/blocks', badge: "NEW" },
                    { label: 'All Blocks', icon: 'pi pi-fw pi-globe', url: 'https://www.primefaces.org/primeblocks-react' }
                ]
            },
            {
                label: 'Icons',
                items: [
                    { label: 'PrimeIcons', icon: 'pi pi-fw pi-prime', to: '/icons' }
                ]
            },
            {
                label: 'Pages', icon: 'pi pi-fw pi-clone',
                items: [
                    { label: 'Crud', icon: 'pi pi-fw pi-user-edit', to: '/crud' },
                    { label: 'Timeline', icon: 'pi pi-fw pi-calendar', to: '/timeline' },
                    { label: 'Empty', icon: 'pi pi-fw pi-circle-off', to: '/empty' }
                ]
            },
        ]

    }

    const menu =[
        {
            label: 'Accueil',
            items: [
                { label: 'Tableau de bord', icon: 'pi pi-fw pi-home', to: '/dashboard' }
            ]
        },
        {
            label: 'Gestion des matériels roulants',
            items: [
                { label: 'Type matériel roulant', icon: 'pi pi-fw pi-list', to: '/typeMateriel' },
                { label: 'Matériel roulant', icon: 'pi pi-fw pi-car', to: '/vehicule' },
                { label: 'Plaque', icon: 'pi pi-fw pi-credit-card', to: '/plaque' },
                { label: 'Financement', icon: 'pi pi-fw pi-list', to: '/financement' },
                { label: 'Etat du matériel', icon: 'pi pi-fw pi-list', to: '/etatMateriel' },
            ]
        },

        {
            label: 'Gestion des chauffeurs',
            items: [
                { label: 'Chauffeur', icon: ' pi pi-fw pi-users', to: '/chauffeur' },
                { label: 'Disponibilité en chauffeur', icon: 'pi pi-fw pi-users', to: '/disponibiliteChauffeur' },
                { label: 'Etat chauffeur', icon: 'pi pi-fw pi-users', to: '/etatChauffeur' },
            ]
        },

        {
            label: 'Gestion des Tiers',
            items: [
                { label: 'Type tiers', icon: 'pi pi-fw pi-list', to: '/typeTiers' },
                { label: 'Tiers', icon: 'pi pi-fw pi-list', to: '/tiers' },
            ]
        },

        {
            label: 'Gestion des missions',
            items: [
                { label: 'Demande de véhicule', icon: 'pi pi-fw pi-car', to: '/demande' },
                { label: 'Traitement des demandes', icon: 'pi pi-fw pi-list', to: '/traitement' },
                { label: 'Disponibilité en véhicule', icon: 'pi pi-fw pi-list', to: '/disponibiliteVehicule' },
            ]
        },

        {
            label: 'Gestion des assurances',
            items: [
                { label: 'Type assurance', icon: 'pi pi-fw pi-list', to: '/typeAssurance' },
                { label: 'Assurance', icon: 'pi pi-fw pi-car', to: '/assurance' },
                { label: 'Point des assurances', icon: 'pi pi-fw pi-list', to: '/pointAssurance' },
            ]
        },

        {
            label: 'Gestion des locations',
            items: [
                { label: 'Location', icon: 'pi pi-fw pi-car', to: '/location' },
                { label: 'Traitement des demandes', icon: 'pi pi-fw pi-list', to: '/traitement' },
                { label: 'Point des locations', icon: 'pi pi-fw pi-list', to: '/pointLocation' },
            ]
        },

        {
            label: 'Gestion des réparations',
            items: [
                { label: 'Type contrat', icon: 'pi pi-fw pi-car', to: '/typeContrat' },
                { label: 'Contrat', icon: 'pi pi-fw pi-car', to: '/contrat' },
                { label: 'Déclaration maintenance', icon: 'pi pi-fw pi-car', to: '/declarationMaintenance' },
                { label: 'Type maintenance', icon: 'pi pi-fw pi-car', to: '/typeMaintenance' },
                { label: 'Maintenance', icon: 'pi pi-fw pi-car', to: '/maintenance' },
                { label: 'Mouvement pièces', icon: 'pi pi-fw pi-car', to: '/mouvementPiece' },
                { label: 'Pièces de rechange', icon: 'pi pi-fw pi-car', to: '/piecesRechange' },
                { label: 'Stock pièces', icon: 'pi pi-fw pi-car', to: '/piecesRechangeStock'}
            ]
        },

        {
            label: ' Autres paramètres',
            items: [
                
                { label: 'Institution', icon: 'pi pi-fw pi-list', to: '/institution' },
                { label: 'Lieu', icon: ' pi pi-fw pi-list', to: '/lieu' },
                { label: 'Niveau', icon: 'pi pi-fw pi-list', to: '/niveau' },
                { label: 'Structure', icon: 'pi pi-fw pi-list', to: '/structure' },
            ]
        },

        {
            label: 'Administration',
            items: [
                { label: 'Compte', icon: ' pi pi-fw pi-user-edit', to: '/compte' },
                { label: 'Utilisateur', icon: 'pi pi-fw pi-users', to: '/utilisateur' },
            ] 
        },

    ]

    return (
        <>
            <AppTopbar onToggleMenuClick={props.onToggleMenuClick} 
                layoutColorMode={props.layoutColorMode}
                mobileTopbarMenuActive={props.mobileTopbarMenuActive} 
                onMobileTopbarMenuClick={props.onMobileTopbarMenuClick} 
                onMobileSubTopbarMenuClick={props.onMobileSubTopbarMenuClick} />

            <div className="layout-sidebar" onClick={props.onSidebarClick}>
                <AppMenu 
                    model={monTableau}  
                   //model= {menu}
                    onMenuItemClick={props.onMenuItemClick} 
                    layoutColorMode={props.layoutColorMode} />
            </div>

            <div className="layout-main-container">
                <div className="layout-main">
                    <Route path="/dashboard" exact render={() => <Dashboard colorMode={props.layoutColorMode} location={props.location} />} />
                    <Route path="/lieu" component={Lieu} />
                    <Route path="/niveau" component={Niveau} />
                    <Route path="/structure" component={Structure} />
                    <Route path="/utilisateur" component={Utilisateur} />
                    <Route path="/vehicule" component={Vehicule} />
                    <Route path="/chauffeur" component={Chauffeur} />
                    <Route path="/compte" component={Compte} />
                    <Route path="/demande" component={DemandeVehicule} />
                    <Route path="/updatePassword" component={UpdatePassword} />
                    <Route path="/traitement" component={Traitement} />
                    <Route path="/responsable" component={ResponTraitement} />
                    <Route path="/pointparking" component={PointParking} />
                    <Route path="/plaque" component={Plaque}/>
                    <Route path="/financement" component={Financement}/>
                    <Route path="/typeMateriel" component={TypeMateriel}/>
                    <Route path="/tiers" component={Tiers}/>
                    <Route path="/typeTiers" component={TypeTiers}/>
                    <Route path="/typeAssurance" component={TypeAssurance}/>
                    <Route path="/assurance" component={Assurance}/>
                    <Route path="/location" component={Location}/>
                    <Route path="/maintenance" component={Maintenance}/>
                    <Route path="/typeMaintenance" component={TypeMaintenance}/>
                    <Route path="/typeContrat" component={TypeContrat}/>
                    <Route path="/contrat" component={Contrat}/>
                    <Route path="/piecesRechange" component={PieceRechange}/>
                    <Route path="/declarationMaintenance" component={DeclarationMaintenance}/>
                    <Route path="/mouvementPiece" component={MouvementPiece}/>
                    <Route path="/pointAssurance" component={PointAssurance}/>
                    <Route path="/etatMateriel" component={EtatMateriel}/>
                    <Route path="/disponibiliteVehicule" component={DisponibiliteVehicule}/>
                    <Route path="/etatChauffeur" component={EtatChauffeur}/>
                    <Route path="/pointLocation" component={PointLocation}/>
                    <Route path="/disponibiliteChauffeur" component={DisponibiliteChauffeur}/>
                    <Route path="/piecesRechangeStock" component={PieceRechangeStock}/>


                    <Route path="/connectedButton" component={ConnectedButton}/>
                
                    <Route path="/formlayout" component={FormLayoutDemo} />
                    <Route path="/input" component={InputDemo} />
                    <Route path="/floatlabel" component={FloatLabelDemo} />
                    <Route path="/invalidstate" component={InvalidStateDemo} />
                    <Route path="/button" component={ButtonDemo} />
                    <Route path="/table" component={TableDemo} />
                    <Route path="/list" component={ListDemo} />
                    <Route path="/tree" component={TreeDemo} />
                    <Route path="/panel" component={PanelDemo} />
                    <Route path="/overlay" component={OverlayDemo} />
                    <Route path="/media" component={MediaDemo} />
                    <Route path="/menu" component={MenuDemo} />
                    <Route path="/messages" component={MessagesDemo} />
                    <Route path="/blocks" component={BlocksDemo} />
                    <Route path="/icons" component={IconsDemo} />
                    <Route path="/file" component={FileDemo} />

                    <Route path="/chart" render={() => <ChartDemo colorMode={props.layoutColorMode} location={props.location} />} />
                    <Route path="/misc" component={MiscDemo} />
                    <Route path="/timeline" component={TimelineDemo} />
                    <Route path="/crud" component={Crud} />
                    <Route path="/empty" component={EmptyPage} />
                    <Route path="/documentation" component={Documentation} />
                    <Route path="/institution" component={Institution} />
                    <Route path="/institution2" component={Institution2} />
                    <Route path="/textTable" component={TextTable} />
                    <Route path="/testTableIns" component={TestTableIns} />
                    <Route path="/sup" component={Suppression} />
                    <Route path="/form" component={Form} />
                </div>
                <AppFooter layoutColorMode={props.layoutColorMode} /> 
            </div>
        </>
    );

}

export default App;
